import React from 'react'
import { Box, Badge } from '@chakra-ui/react'
import {
  handleSpecificLabelBusiness,
  handleSpecificLabelCategory,
  handleSpecificLabelOffer,
  handleInvexSpecificLabelOffer,
  handleSpecificLabelPrice
} from '../../../filters'

const BadgeFilter = ({
  accentColor,
  currentFilter,
  handleFilter,
  type,
  lang,
  dictionary,
  skin
}) => {
  const handleSpecificLabel = () => {
    if (type === 'category') {
      return `${handleSpecificLabelCategory(lang, currentFilter)} x`
    } else if (type === 'offerType' && skin === 'INVEX') {
      return handleInvexSpecificLabelOffer(dictionary, currentFilter?.label)
    } else if (type === 'offerType') {
      return handleSpecificLabelOffer(dictionary, currentFilter?.label)
    } else if (type === 'priceLevel') {
      return handleSpecificLabelPrice(dictionary, currentFilter?.label)
    } else if (type === 'businessType') {
      return handleSpecificLabelBusiness(dictionary, currentFilter?.label)
    } else {
      return `${currentFilter?.label} x`
    }
  }

  return (
    <Box p='0.5rem'>
      <Badge
        fontSize='0.8rem'
        bg={
          type === 'clean'
            ? 'transparent'
            : skin === 'COPPEL'
            ? accentColor
            : 'white'
        }
        variant='solid'
        color={
          type === 'clean'
            ? accentColor
            : skin === 'COPPEL'
            ? 'brand.white'
            : '#001B69'
        }
        border={`${type === 'clean' ? null : `2px solid ${accentColor}`}`}
        borderRadius={skin === 'COPPEL' ? '167px' : (skin === 'FINSUS' ? '4px' : skin === 'ALBO' ? '6px':'12px')}
        p='0.3rem 0.5rem'
        shadow='xl'
        onClick={() => handleFilter(type ? currentFilter : undefined)}
        cursor='pointer'
      >
        {handleSpecificLabel()}
      </Badge>
    </Box>
  )
}

export default BadgeFilter
